/* ═══ SMOOTH SCROLL (one-page) ═══ */
function smoothScrollTo(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const offset = 64;
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: top, behavior: 'smooth' });
  // Close mobile drawer if open
  document.getElementById('sh-landing-ham').classList.remove('sh-landing-open');
  document.getElementById('sh-landing-mob-drawer').classList.remove('sh-landing-open');
}

document.addEventListener('click', function(e) {
  const el = e.target.closest('[data-scroll]');
  if (!el) return;
  e.preventDefault();
  smoothScrollTo(el.dataset.scroll);
});

/* ═══ NAV STICKY ═══ */
// window.addEventListener('scroll', function() {
//   document.getElementById('sh-landing-nav').classList.toggle('sh-landing-stuck', window.scrollY > 20);
// }, { passive: true });

/* ═══ NAV STICKY + HIDE ON SCROLL DOWN, SHOW ON SCROLL UP ═══ */
(function() {
  var nav = document.getElementById('sh-landing-nav');
  if (!nav) return;

  var lastScroll = window.scrollY;
  var ticking = false;

  function onScroll() {
    var currentScroll = window.scrollY;

    // background/blur jab thoda scroll ho
    nav.classList.toggle('sh-landing-stuck', currentScroll > 20);

    // top ke bahut kareeb ho to hamesha dikhao
    if (currentScroll <= 20) {
      nav.classList.remove('sh-landing-nav-hide');
    }
    // niche scroll ho raha ho -> hide
    else if (currentScroll > lastScroll) {
      nav.classList.add('sh-landing-nav-hide');
    }
    // upar scroll ho raha ho -> show
    else if (currentScroll < lastScroll) {
      nav.classList.remove('sh-landing-nav-hide');
    }

    lastScroll = currentScroll;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();

/* ═══ HAMBURGER ═══ */
// document.getElementById('sh-landing-ham').addEventListener('click', function() {
//   this.classList.toggle('sh-landing-open');
//   document.getElementById('sh-landing-mob-drawer').classList.toggle('sh-landing-open');
// });

const ham = document.getElementById('sh-landing-ham');
const drawer = document.getElementById('sh-landing-mob-drawer');

if(ham && drawer) {
  ham.addEventListener('click', function () {
      ham.classList.toggle('sh-landing-open');
      drawer.classList.toggle('sh-landing-open');
  });
}




/* ═══ CUSTOM CURSOR ═══ */
(function() {
  var cur = document.getElementById('sh-landing-cursor');
  if (!cur || window.matchMedia('(pointer:coarse)').matches) return;
  var mx = 0, my = 0, rx = 0, ry = 0;
  var dot = cur.querySelector('.sh-landing-cursor-dot');
  var ring = cur.querySelector('.sh-landing-cursor-ring');
  document.addEventListener('mousemove', function(e) { mx = e.clientX; my = e.clientY; });
  (function loop() {
    rx += (mx - rx) * 0.12; ry += (my - ry) * 0.12;
    dot.style.transform  = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';
    ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
    requestAnimationFrame(loop);
  })();
  document.querySelectorAll('.sh-landing-btn,.sh-landing-card,.sh-landing-tcat,.sh-landing-testi,.sh-landing-nav-link,.sh-landing-tab').forEach(function(el) {
    el.addEventListener('mouseenter', function() { cur.classList.add('sh-landing-hover'); });
    el.addEventListener('mouseleave', function() { cur.classList.remove('sh-landing-hover'); });
  });
})();

/* ═══ MAGNETIC BUTTONS ═══ */
document.querySelectorAll('.sh-landing-mag').forEach(function(wrap) {
  var btn = wrap.querySelector('.sh-landing-btn');
  if (!btn) return;
  wrap.addEventListener('mousemove', function(e) {
    var r = wrap.getBoundingClientRect();
    var x = (e.clientX - r.left - r.width  / 2) * 0.28;
    var y = (e.clientY - r.top  - r.height / 2) * 0.28;
    btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
  });
  wrap.addEventListener('mouseleave', function() { btn.style.transform = ''; });
});

/* ═══ SCROLL REVEAL ═══ */
var rvObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) { e.target.classList.add('sh-landing-on'); rvObs.unobserve(e.target); }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('[data-reveal]').forEach(function(el) { rvObs.observe(el); });

/* ═══ ANIMATED COUNTERS ═══ */
function animCounter(el) {
  var target = parseFloat(el.dataset.count);
  var suffix = el.dataset.suffix || '';
  var dec = el.dataset.dec === '1';
  var dur = 2000, step = 16, elapsed = 0;
  var t = setInterval(function() {
    elapsed += step;
    var p = Math.min(elapsed / dur, 1);
    var ease = 1 - Math.pow(1 - p, 4);
    var v = target * ease;
    el.textContent = (dec ? v.toFixed(1) : Math.round(v)) + suffix;
    if (p >= 1) { el.textContent = (dec ? target.toFixed(1) : target) + suffix; clearInterval(t); }
  }, step);
}

var cntObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.querySelectorAll('[data-count]').forEach(animCounter);
      cntObs.unobserve(e.target);
    }
  });
}, { threshold: 0.3 });

var statsEl = document.querySelector('.sh-landing-stats-row');
if (statsEl) cntObs.observe(statsEl);

